import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useTranslation } from 'react-i18next';
// import { EyeFilled, EyeInvisibleOutlined } from '@ant-design/icons';
import { useLifeUserValidate } from 'all-in-one-shared-api';
import eyeOpen from 'assets/images/Mask.svg';
import eyeClose from 'assets/images/redMask.svg';
import { Alert, Button, Card, Form, Input, Row, Col } from 'antd';
import StyledCheckbox from '../components/StyledCheckbox';
import styled from 'styled-components';
import { Wrapper } from 'pages/life/forget/styledComponents';
import { Typography } from 'antd';
// import regIcon from 'assets/images/register-icon.svg';
import { ActionType, RegistrationFlowContext } from 'contexts/registration';
import { RegistrationFormData } from 'contexts/registration/registrationFormData';
// import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
// import { DEFAULT_DATE_FORMAT, disabledDate } from 'utils';
// import { IconTitle } from 'components';
import PolicyAndMemberIdModal from '../../forget/PolicyAndMemberIdModal';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { revalidateAntdFormLanguageChanged } from '../../../../i18n';
import { StyledTitle } from 'components/StyledTitle';
import ProgressSteps from '../components/ProgressSteps';
import moment from 'moment';
// import { AgreementCheckbox } from '../components/AgreeCheckbox';
import { setErrorCodeFun } from 'utils/setErrorCodeFun/setErrorCodeFun';
import { AgreementCheckboxLI } from 'components/agreementCheckboxforget';
import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
// import _get from 'lodash/get';
// const { Text } = Typography;
const RegistrationCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  padding-left: 200px;
  padding-right: 200px;

  @media (max-width: 992px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
const ResponsiveContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;

  @media (max-width: 992px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
const FormWrapper = styled.div`
  display: grid;
  row-gap: 12px;
  width: 550px;
  @media (max-width: 576px) {
    width: 350px;
    maxwidth: 100%;
  }
`;

function LifeRegistrationSubmissionPage() {
  const initialValues = useRegistrationStateQuery();
  const [errmessage, setErrmessage] = useState<string | null>(null);
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [password, setPassword] = useState('');
  // const [ApiError, setApiError] = useState<string | null>(null);
  const { t, i18n } = useTranslation();
  // const initialValues = useRegistrationStateQuery();
  const [registrationState, setRegistrationState] = useState<RegistrationFormData>({});
  const { state, dispatch, selectFlag } = useContext(RegistrationFlowContext);

  // const [setMobilePrefix] = useState(initialValues.countryCode || defaultPrefix);
  const navigate = useNavigate();
  // const dateFormat = DEFAULT_DATE_FORMAT;
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  // const emailRef = React.useRef<InputRef>(null);
  const [errors, setErrors] = useState<string | null>(null);

  const [form] = Form.useForm();
  const [randoms, setRandoms] = useState(0);
  const onChange = () => {
    setIsAgreed(!isAgreed);
  };
  const location = useLocation() as {
    pathname: string;
    state: {
      policyNumber: string;
      memberId: string;
      birthDate: string;
      memberType: '0';
      registNum?: boolean;
    };
  };

  const handleToggleVisibility = () => {
    setVisible(!visible);
  };
  const handleToggleVisibility2 = () => {
    setVisible2(!visible2);
  };
  // const identityNo = registrationState.identityNo ?? '';
  // const dob = registrationState.dob ?? '';
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [form, i18n.language]);
  const moblieNumber = initialValues.email ? '' : initialValues.mobile;
  const countryCode = initialValues.email ? '' : initialValues.countryCode;
  const { data, error, shouldFetch, isLoading } = useLifeUserValidate(
    'lifeUserValidate' + randoms,
    initialValues.identityNo ?? '',
    initialValues.email ?? '',
    registrationState.selfDefinedLoginId ?? '',
    registrationState.confirmPassword ?? '',
    i18n.language,
    moblieNumber ?? '',
    countryCode ?? '',
    initialValues.areaCode ?? '',
    initialValues.dob ? moment(initialValues.dob).format('DD/MM/YYYY') : '',
    selectFlag ?? '',
    initialValues.policyNumber ?? '',
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      onSuccess: () => {
        // setStartLoading(false);
      },
      onError: () => {
        // setStartLoading(false);
        // const message = setErrorCodeFun(err.code, i18n.language);
        // setErrmessage(err);
      },
    },
  );
  /* eslint-disable */
  useEffect(() => {
    console.log(location?.state?.registNum, 'location.state.registNum');
  }, [location]);
  useEffect(() => {
    if (data && !error) {
      console.log('registrationState____________________', registrationState);
      dispatch({
        type: ActionType.UpdateFormData,
        payload: {
          selfDefinedLoginId: registrationState.selfDefinedLoginId,
          password: registrationState.password,
          confirmPassword: registrationState.confirmPassword,
        },
      });
      navigate('/register/otp-verification', {
        replace: true,
        state: {
          loginId: state.selfDefinedLoginId || initialValues.selfDefinedLoginId || '',
          mobile: initialValues.mobile ?? '',
          email: initialValues.email ?? '',
          countryCode: initialValues.countryCode ?? '',
          prevPath: location.pathname ?? '',
          registNum: location.state.registNum,
          areaCode: initialValues.areaCode ?? '',
        },
      });
    } else {
      if (error && error?.code) {
        // shouldFetch(false);
        setErrors(error.code);
        const errorMessage = setErrorCodeFun(error.code, i18n.language);
        console.log('error', error);
        setErrmessage(errorMessage);
        // setApiError(error.message);
      }
      return;
    }
    if (i18n.language && errors) {
      const message = setErrorCodeFun(errors, i18n.language);
      setErrmessage(message);
    }
  }, [data, error, navigate, shouldFetch, i18n.language, errors]);

  useEffect(() => {
    setRandoms(Math.random());
    return () => {
      shouldFetch(false);
    };
  }, [shouldFetch]);
  const handleCloseSnackbar = () => {
    setSnackbarMessage('');
  };

  const onValidateSuccessful = React.useCallback(
    (data: RegistrationFormData, event?: React.BaseSyntheticEvent) => {
      setRandoms(Math.random());
      shouldFetch(true);
      // setLoading(true);
      // setApiError(null);
      // navigation.navigate('RegistrationSubmissionWithLifeInsuranceScreen');
      event && event.preventDefault();
    },
    [shouldFetch],
  );

  const onFinish = (values: RegistrationFormData) => {
    console.log('value', values);
    dispatch({
      type: ActionType.UpdateFormData,
      payload: {
        selfDefinedLoginId: registrationState.selfDefinedLoginId,
        password: registrationState.password,
        confirmPassword: registrationState.confirmPassword,
      },
    });

    // navigate('/register/otp-verification'); //提交时注释掉
    // setRegistrationState({
    //   ...values,
    // });
    onValidateSuccessful(registrationState);
  };
  // useEffect(() => {
  //   // if (registrationState.confirmPassword && registrationState.password) {
  //   onValidateSuccessful(registrationState);
  //   // }
  // }, [onValidateSuccessful, registrationState]);
  const isValid = registrationState.selfDefinedLoginId?.trim() !== '' && registrationState.confirmPassword;
  console.log(
    'selfDefinedLoginId',
    registrationState.selfDefinedLoginId,
    'confirmPassword',
    registrationState.confirmPassword,
  );
  // const handleChange = (value: string) => {
  //   setMobilePrefix(value);
  // };

  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  const closeModel = () => {
    setIsModalVisible(false);
  };
  console.log('isvalid', isValid);
  // const prefixSelector = <MobileNumberPrefix handleChange={handleChange} />;
  // const infoIcon = <InfoCircleOutlined style={{ cursor: 'pointer' }} onClick={showModal} />;
  useEffect(() => {
    console.log('Current password value:', password);
  }, [password]);
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };
  return (
    <ResponsiveContainer>
      {/* <IconTitle title={t('launch.registerBtn')} level={2} icon={regIcon} /> */}
      <RegistrationCard
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '0',
        }}
      >
        <Wrapper style={{ backgroundColor: 'white', borderRadius: 0, border: 0 }}>
          {/* <StyledTitle level={4}>{t('registration.info')}</StyledTitle> */}
          {/* <Divider /> */}
          {/* <Row
            justify="center"
            gutter={[16, { xs: 8, sm: 16, md: 24 }]}
            // style={{ backgroundColor: 'yellow', borderRadius: 0, border: 0 }}
          ></Row> */}
          <Row
            justify="center"
            gutter={[16, { xs: 8, sm: 16, md: 24 }]}
            style={{ backgroundColor: 'white', borderRadius: 0, border: 0 }}
          >
            <Form
              initialValues={{
                ...registrationState,
              }}
              layout={'vertical'}
              requiredMark={false}
              onFinish={onFinish}
              form={form}
              validateTrigger={'onBlur'}
              style={{
                width: '100%',
                background: 'pink',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onValuesChange={(changedValues) => {
                // 合并所有更改到 registrationState 中
                setRegistrationState((prevState) => ({
                  ...prevState, // 保留之前的状态
                  ...changedValues, // 只更新 changedValues 中的字段
                }));
              }}
            >
              <FormWrapper style={{ background: 'white' }}>
                <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
                  <ProgressSteps activeStepIndex={1} />
                </Col>
                <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      // backgroundColor: 'pink',
                    }}
                  >
                    <StyledTitle level={5} type="secondary" margin="0 0 24px 0" fontSize="26px" color="#20252B">
                      {t('registration.createProfileTitle')}
                    </StyledTitle>
                    {/* <Divider /> */}
                  </div>
                </Col>
                {/* <Col xs={24} md={24}>
              <StyledTitle level={5} type="secondary">
                {t('registration.greeting', {
                  memberName: state.memberName,
                })}
              </StyledTitle>
            </Col> */}
                <Col xs={24} md={24}>
                  <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }}>
                    {t('registration.submissionLabel')}
                  </Typography.Text>
                </Col>
                <Col xs={24} md={24}>
                  <Typography.Text style={{ color: '#752127', fontSize: '17px', fontFamily: 'Roboto400' }}>
                    {t('forgetPassword.mandatoryMsg')}
                  </Typography.Text>
                </Col>
                <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
                  {!!snackbarMessage && (
                    <Alert
                      className="custom-alert"
                      message={t(snackbarMessage)}
                      type="error"
                      onClose={handleCloseSnackbar}
                      style={{ marginBottom: 16 }}
                    />
                  )}
                </Col>
                <Col xs={24} md={24} style={{ width: '100%', backgroundColor: 'white' }}>
                  <BoldLabelFormItem
                    style={{ marginBottom: '10px' }}
                    label={
                      <span
                        style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}
                      >
                        {t('registration.EB.loginId')}
                      </span>
                    }
                    name="selfDefinedLoginId"
                    rules={[
                      { required: true, message: t('registration.error.required') },
                      {
                        validator: (_, value) => {
                          const trimmedValue = value?.trim();

                          // 验证最大长度和最小长度
                          if (trimmedValue && (trimmedValue.length > 20 || trimmedValue.length < 6)) {
                            return Promise.reject(new Error(t('registration.error.invalidLoginId')));
                          }

                          // 使用正则表达式验证
                          const loginIdRegex = /^[a-zA-Z0-9_]+$/; // 假设这是 loginIdRegex 的正则表达式
                          if (!loginIdRegex.test(trimmedValue)) {
                            return Promise.reject(new Error(t('registration.error.invalidLoginId')));
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      size="middle"
                      maxLength={20}
                      // disabled={initialValues.isEmailRegister}
                      placeholder={t('registration.EB.loginIdHolder')}
                      style={{
                        paddingLeft: 0,
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        border: 'none',
                        borderBottom: '1px solid #E5E5E5',
                        // color: "white",
                        backgroundColor: 'transparent',
                      }}
                    />
                  </BoldLabelFormItem>
                  <Typography.Text
                    style={{
                      display: 'block',
                      fontFamily: 'Roboto400',
                      fontSize: '17px',
                      color: '#B0B2B3',
                    }}
                    type="secondary"
                  >
                    {t('registration.EB.loginIdvalidation')}
                  </Typography.Text>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}
                      >
                        {t('registration.EB.passwordTitle')}
                      </span>
                    }
                    name="password"
                    // rules={[
                    //   { required: true, message: t("registration.error.required") },
                    //   {
                    //     validator: (rule, value) => {
                    //       if (value.length < 8 || value.length > 12) {
                    //         return Promise.reject(
                    //           new Error(t("registration.error.passwordLength"))
                    //         );
                    //       }
                    //       if (!/[a-zA-Z]/.test(value) || !/\d/.test(value)) {
                    //         return Promise.reject(
                    //           new Error(t("registration.error.passwordValidation1"))
                    //         );
                    //       }
                    //       if (!/[A-Z]/.test(value) || !/[a-z]/.test(value)) {
                    //         return Promise.reject(
                    //           new Error(t("registration.error.passwordValidation2"))
                    //         );
                    //       }
                    //       return Promise.resolve();
                    //     },
                    //   },
                    // ]}
                  >
                    <div style={{ position: 'relative' }}>
                      <Input
                        size="middle"
                        maxLength={12}
                        // disabled={initialValues.isEmailRegister}
                        placeholder={t('registration.EB.passwordHolder')}
                        style={{
                          paddingLeft: 0,
                          border: 'none',
                          borderBottom: '1px solid #E5E5E5',
                          fontSize: '20px',
                          fontFamily: 'Roboto400',
                          // color: "white",
                          backgroundColor: 'transparent',
                        }}
                        onChange={handlePasswordChange}
                        type={visible ? 'text' : 'password'}
                        // placeholder={placeholder}
                      />
                      <img
                        src={visible ? eyeOpen : eyeClose}
                        alt="toggle visibility"
                        style={{ cursor: 'pointer', width: 20, height: 20, position: 'absolute', top: 10, right: 10 }}
                        onClick={handleToggleVisibility}
                      />
                    </div>
                    <div style={{ marginTop: 16 }}>
                      <div>
                        <StyledCheckbox
                          checked={password?.length >= 8 && /[a-zA-Z]/.test(password) && /\d/.test(password)}
                        >
                          <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }}>
                            {t('forgetPassword.Minimumcharacters')}
                          </Typography.Text>
                        </StyledCheckbox>
                      </div>
                      <div>
                        <StyledCheckbox checked={/[A-Z]/.test(password) && /[a-z]/.test(password)}>
                          <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }}>
                            {t('forgetPassword.ContainsUppercase')}
                          </Typography.Text>
                        </StyledCheckbox>
                      </div>
                      <div>
                        <StyledCheckbox checked={/\d/.test(password)}>
                          <Typography.Text style={{ fontSize: '17px', fontFamily: 'Roboto400' }}>
                            {t('forgetPassword.ContainsDigit')}
                          </Typography.Text>
                        </StyledCheckbox>
                      </div>
                    </div>
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    label={
                      <span
                        style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}
                      >
                        {t('registration.confirmLabel') + '*'}
                      </span>
                    }
                    name="confirmPassword"
                    dependencies={['password']}
                    rules={[
                      { required: true, message: t('registration.error.required') },
                      () => ({
                        validator(_, value) {
                          console.log('value', value, 'getFieldValue', password);
                          if (!value || password === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error(t('registration.error.invalidConfirmPassword')));
                        },
                      }),
                    ]}
                  >
                    <div style={{ position: 'relative' }}>
                      <Input
                        size="middle"
                        maxLength={12}
                        // disabled={initialValues.isEmailRegister}
                        placeholder={t('resetPassword.confirmPasswordPlaceholder')}
                        style={{
                          paddingLeft: 0,
                          border: 'none',
                          borderBottom: '1px solid #E5E5E5',
                          // color: "white",
                          fontSize: '20px',
                          fontFamily: 'Roboto400',
                          backgroundColor: 'transparent',
                        }}
                        type={visible2 ? 'text' : 'password'}
                        // placeholder={placeholder}
                      />
                      <img
                        src={visible2 ? eyeOpen : eyeClose}
                        alt="toggle visibility"
                        style={{ cursor: 'pointer', width: 20, height: 20, position: 'absolute', top: 10, right: 10 }}
                        onClick={handleToggleVisibility2}
                      />
                    </div>
                  </BoldLabelFormItem>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                  {/* <Checkbox checked={isAgreed} onChange={(e: CheckboxChangeEvent) => setIsAgreed(e.target.checked)}>
                  <Text style={{ marginRight: 4 }}>{t('newClaim.reviewInfo.agreementTo')}</Text>
                  <Link to="/declaration-statement" target="_blank">
                    {t('newClaim.reviewInfo.declaration')}
                  </Link>
                </Checkbox> */}
                  <BoldLabelFormItem style={{ borderTop: '1px solid #cccccc' }}>
                    <AgreementCheckboxLI onChange={onChange} />
                  </BoldLabelFormItem>
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      // backgroundColor: 'pink',
                    }}
                  >
                    <BoldLabelFormItem style={{ width: '80%' }}>
                      {/* <Row gutter={[16, { xs: 24, sm: 24, md: 24 }]}> */}
                      {errmessage && (
                        <Alert
                          className="custom-alert"
                          message={errmessage}
                          type="error"
                          style={{
                            marginTop: 16,
                            border: 'none',
                          }}
                        />
                      )}
                      <Button
                        block
                        type="primary"
                        // loading={
                        //   (isLoading && isCheckExistingMemberLoading) || (isLoadingvalidate && isCheckExistingMemberLoading)
                        // }
                        loading={isLoading}
                        style={{
                          marginTop: 24,
                          // maxWidth: '100%',
                          fontFamily: 'Roboto500',
                          fontSize: '20px',
                          height: '56px',
                          width: '100%',
                        }}
                        disabled={!isAgreed || !isValid}
                        size="large"
                        htmlType="submit"
                      >
                        {t('common.submit')}
                      </Button>
                      {/* </Row> */}
                    </BoldLabelFormItem>
                  </div>
                </Col>
              </FormWrapper>
            </Form>
          </Row>
        </Wrapper>
      </RegistrationCard>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </ResponsiveContainer>
  );
}

export default LifeRegistrationSubmissionPage;
